import { SPACE } from '../../../constants/keyboardKeyCode';

const Realize = {
  Label: window.Label,
};

export default class Label extends Realize.Label {
  constructor (props) {
    super(props);

    this.state = {
      isChecked: false,
    }
  }

  handleKeyDown (event) {
    if (event.keyCode === SPACE) {
      event.stopPropagation();
      event.preventDefault();

      event.currentTarget.click();
      event.currentTarget.focus();
    }
  }

  render () {
    const {
      id,
      checked,
      label,
      disabled,
      required,
      role,
      onClick
    } = this.props;

    if (label === false) {
      return <span />;
    }

    let text = String(label || '');

    if (required) {
      text += ' *';
    }

    return (
      <label
        htmlFor={id}
        aria-checked={checked}
        aria-disabled={disabled}
        className={this.className()}
        tabIndex={0}
        role={role}
        onClick={(event) => onClick?.(event)}
        onKeyDown={this.handleKeyDown.bind(this)}
      >
        {text}
      </label>
    )
  }
}
